<template>
  <div class="content-child-row">
    <div class="row-info">
      <a class="child-row-name">
        <span class="person-name">{{ title }}</span>
      </a>
    </div>

    <div class="row-drawer" v-if="showForecast">
      <div class="drawer-inner">{{ resourceFuturePlannedHours | nodecimalorline }}{{ (resourceFuturePlannedHours ? forecastUnitType : '') }}</div>
    </div>
    <div class="row-timeline">
      
      <div style="position: absolute;width: 100%; height: 30px; background: transparent;" 
      :title="getTitle"
        @mousemove="timeLineMouseMove"
        @mouseover="timeLineMouseOver"
        @mouseout="timeLineMouseOut"
        @mouseleave="timeLineMouseLeft"
        @mousedown="addAllocationMouseDown"
        @mouseup="addAllocationMouseUp">
        <div
          :style="{ width: addWidth + 'px', left: addHover.addLocation + 'px' }"
          class="add-assignment"
          :class="[addHover.showAdd ? '' : 'is-hidden', projectColor]"
          width="48">
          <div class="ui-resizable-handle ui-resizable-e" style="z-index: 90;"></div>
        </div>
      </div>
      
      <template v-if="mainConfig.store !== null">
        <div v-for="(item) of mainConfig.store"
            :key="item[mainConfig.idProperty]"
            @click="mainConfigItemClicked($event, item)"
            :style="{ width: assignmentWidth(item[mainConfig.widthProperty]) + 'px', left: assignmentStart(item[mainConfig.startProperty]) + 'px' }"
            class="assignment ui-draggable ui-draggable-handle ui-resizable"
            :class="[colorMap(item), item[mainConfig.classTypeProperty], allocationSelectionClass(item)]"
            :title="getAllocationLabel(item[mainConfig.classTypeProperty])">
            <slot name="default" :dataItem="item">

            </slot>
        </div>
        <slot name="mainEditDialogComponent" :editDialog="editDialog" :closeEdit="closeEdit">

        </slot>
        <!-- <div
          title="Split this assignment"
          style="left: 0px;"
          class="split-line gtm-split-assignment"
        ></div>
        <div
          @mousedown="allocationResizeMouseDown(allocation.startDate)"
          @mouseup="allocationResizeMouseUp(allocation.endDateInclusive)"
          class="ui-resizable-handle ui-resizable-e"
          style="z-index: 90;"></div>
        <div
          @mousedown="allocationResizeMouseDown(allocation.endDateInclusive)"
          @mouseup="allocationResizeMouseUp(allocation.endDateInclusive)"
          class="ui-resizable-handle ui-resizable-w"
          style="z-index: 90;"></div> -->
      </template>

      <div v-for="(config, index) in otherConfigs" 
      :key="index">
        <div v-for="(otherItem) of config.store" 
        :key="otherItem[config.idProperty]"
          :style="{ width: assignmentWidth(otherItem[config.widthProperty]) + 'px', left: assignmentStart(otherItem[config.startProperty]) + 'px' }"
          :class="config.classProperty"></div>
      </div>

      <template v-if="alertConfig.store !== null">
        <div v-for="(alertItem) of alertConfig.store"
             :key="alertItem[alertConfig.idProperty]"
             :style="{ width: assignmentWidth(1) + 'px', left: assignmentStart(alertItem[alertConfig.startProperty] ) + 'px' }"
             class="overallocated-frame">
        </div>
      </template>
      <div
        v-for="(overallocation) of resourceOverallocations" v-bind:key="overallocation.id"
        :style="{ width: assignmentWidth(1) + 'px', left: assignmentStart(overallocation.date) + 'px' }"
        class="overallocated-frame"></div>    

    </div>

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import forecastTypes from './constants/forecastTypes';

const UNIT_WIDTH = 48;

export default {
  name: 'ScheduleResourceRow',
  components: {

  },
  props: {
    userCanEdit: {
      type: Boolean,
      default: true
    },
    projectId: {
      type: String,
      default: null,
    },
    role: {
      type: String,
      default: null,
    },
    employeeId: {
      type: String,
      default: null,
    },
    replacementId: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: "Ferie/Fri",
    },
    projectColor: {
      type: String,
      default: "black",
      validator: function (value) {
        return ['orange','green','aqua','blue','purple','magenta','red','gray','black','yellow'].indexOf(value) !== -1;
      }
    },
    showForecast: {
      type: Boolean,
      default: false,
    },
    viewStartDate: {
      type: Date,
    },
    zoomLevel: {
      type: Number,
      default: 1,
      validator: function (value) {
        // The value must be 1 or 2
        return [1,2].indexOf(value) !== -1
      },
    },
    mainConfig: {
      type: Object,
      default: () => ({ 
        store: null, 
        idProperty: null, 
        widthProperty: null, 
        startProperty: null, 
        classTypeProperty: null 
      })
    },
    alertConfig: {
      type: Object,
      default: () => ({ store: null, idProperty: null, startProperty: null })
    },
    otherConfigs: {
      type: Array,
      default: () => ([{ store: null, idProperty: null, startProperty: null, widthProperty: null, classProperty: null }])
    }
  },
  data() {
    return {
      addHover: {
        addLocation: 0,
        showAdd: false,
        addInprogress: false,
        addSize: 0,
      },
      editDialog: {
        show: false,
        item: {},
        top: 0,
        left: 0,
      },
    };
  },
  methods: {
    ...mapActions('allocationMoverStore', ['selectAllocation']),
    assignmentWidth(durationInDays) {
      return durationInDays * this.dayUnitSize;
    },
    assignmentStart(startDate) {
      var spanInDays = moment.utc(startDate).diff(moment.utc(this.viewStartDate), 'days');
      return spanInDays * UNIT_WIDTH / this.zoomLevel;
    },
    timeLineMouseOver() {
      if(this.userCanEdit === false){
        return;
      }
      this.addHover.showAdd = true;
    },
    timeLineMouseOut() {
      if(this.userCanEdit === false){
        return;
      }
      this.addHover.showAdd = false;
      this.addHover.addSize = 0;
    },
    timeLineMouseLeft() {
      if(this.userCanEdit === false){
        return;
      }
      this.addHover.addInprogress = false;
      this.addHover.addSize = 0;
    },
    timeLineMouseMove(e) {
      if(this.userCanEdit === false){
        return;
      }
      var rowOffset = e.clientX - this.firstDayOffset;
      
      if(this.addHover.addInprogress) {
        var width = rowOffset - this.addHover.addLocation;
        this.addHover.addSize = (width - (width % this.dayUnitSize) + this.dayUnitSize);
      }
      else {
        this.addHover.addLocation = rowOffset - (rowOffset % this.dayUnitSize);
      }
    },
    // allocationResizeMouseDown(date) {
      
    // },
    // allocationResizeMouseUp(date) {
      
    // },
    addAllocationMouseDown() {
      if(this.userCanEdit === false){
        return;
      }

      this.addHover.addInprogress = true;
    },
    addAllocationMouseUp() {
      // TODO: check for overlapping allocations on same resource
      if(this.userCanEdit === false){
        return;
      }

      if(this.addDaySpan > 0) {
        this.$emit('add-allocation', {
          allocationType: this.defaultAllocationType,
          circleId: this.projectId,
          employeeId: this.employeeId,
          startDate: this.addStartDate,
          allocationSpanInDays: this.addDaySpan,
        });
        this.addHover.addInprogress = false;
        this.addHover.addSize = 0;
      }      
    },
    resourceRowClicked() {
      this.$emit('resource-clicked', {
        circleId: this.projectId,
        employeeId: this.employeeId
      });
    },
    showEdit(e, item) {
      this.editDialog.item = item;
      this.editDialog.left = e.clientX;
      this.editDialog.top = e.clientY;
      this.editDialog.show = true;
    },
    closeEdit() {
      this.editDialog.show = false;
    },
    colorMap(arg) {
      if(arg?.replacementId && arg.employeeId === this.employeeId) {
        return "green";
      }

      if(arg.allocationType === "OFFDAY" && !arg.circleId) {        
        return "yellow";
      }

      return this.projectColor;
    },
    getAllocationLabel(allocationType) {
      if(!allocationType) {
        return 'ARB';
      }
      let label = allocationType
      if(this.allocationTypesReport) {
        let obj = this.allocationTypesReport.find(o => o.key === allocationType);
        if(obj) {
            label = obj.label;  
        }
      }

      if(this.allocationTypes) {
        label = this.allocationTypes[allocationType];
      }

      return label;
    },
    mainConfigItemClicked($event, item) {
      if(this.userCanEdit === false){
        return;
      }
      if ($event.ctrlKey === true) {
        this.selectAllocation(item);

      }
      else {
        this.showEdit($event, item)
      }
    }
  },
  computed: {
    clientName() {
      var client = this.clientLookup[this.projectClientId];
      return client ? client.name : '';
    },
    firstDayOffset() {
      return (this.showForecast ? 419 : 319);
    },
    dayUnitSize() {
      return UNIT_WIDTH / this.zoomLevel;
    },
    addWidth() {
      return (this.addHover.addInprogress ? this.addHover.addSize : this.dayUnitSize);
    },
    addStartDate() {
      return moment.utc(this.viewStartDate).add((this.addHover.addLocation / this.dayUnitSize), 'days').startOf('day').toDate();
    },
    addDaySpan() {
      return this.addWidth / this.dayUnitSize;
    },
    getTitle(){
      return moment(this.addStartDate).format("ddd, DD");
    },
    getShortTitle(){
      return moment(this.addStartDate).format("DD");
    },
    defaultAllocationType() {      
      if (this.projectId) { 
        return "WORK";
      }       
      if (this.role && this.role !== "Replacement") { 
        return "VACATION";
      }

      return "OFFDAY";
    },
    resourceOverallocations() {
      return this.overallocations.byEmployeeCircle[`${this.employeeId}-${this.projectId}`];
    },
    resourceFuturePlannedHours() {
      if(this.forecasts.byEmployeeProject[`${this.employeeId}-${this.projectId}`]) {
        return this.forecasts.byEmployeeProject[`${this.employeeId}-${this.projectId}`].reduce((map, obj) => {
          map += obj.futurePlannedHours;
          return map;
        }, 0.0);
      }
      return 0.0;
    },
    forecastUnitType() {
      return forecastTypes[this.groupBy][this.forecastType].unit;
    },
    ...mapGetters('metadata', ['allocationTypesReport','allocationTypes']),
    ...mapGetters('scheduler', [
      'clientLookup',
      'employeeLookup',
      'allocations',
      'milestones',
      'overallocations',
      'forecasts',
      'groupBy',
      'forecastType',
    ]),
    ...mapGetters('allocationMoverStore', ['allocationSelectionClass']),

  }
}
</script>
<style lang="scss" scoped>
.assignment
{
  &.HOLIDAY {
    border-bottom: 6px solid #4e698c;
  }
  &.SICKDAY {
    border-bottom: 6px solid #8c5353;
  }
  &.SICKDAYWORK {
    border-bottom: 6px solid #8c5353;
  }
  &.VACATION {
    border-bottom: 6px solid #356541;
  }
  &.MATERNETY {
    border-bottom: 6px solid #753777;
  }
  &.PATERNATY {
    border-bottom: 6px solid #753777;
  }
}
</style>
